import { MuiThemeProvider } from '@material-ui/core/styles';

/** @deprecated */
export default MuiThemeProvider;
